import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Link2, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { OwnerBadge } from "@/threedvista/TdvDemo";

export default function GiraffeDemo() {
  const nav = useNavigate();
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const go = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const { data } = await api.post("/public/g360-demo", { url: url.trim() });
      localStorage.setItem(`tdv_demo_${data.id}`, data.token);
      nav(`/3d/${data.id}`);
    } catch (x) { setErr(errMsg(x)); setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[#0B1220] text-white" data-testid="g360-demo-page">
      <header className="max-w-6xl mx-auto px-6 h-20 flex items-center"><Link to="/giraffe" className="font-serif text-xl">Showhome <span className="text-[#C9A227]">for Giraffe360</span></Link></header>
      <main className="max-w-3xl mx-auto px-6 pt-12 pb-24">
        <p className="text-xs uppercase tracking-[0.3em] text-[#C9A227]">Free demo · no sign-up</p>
        <h1 className="font-serif text-4xl sm:text-5xl mt-4">See your Giraffe360 tour with Showhome.</h1>
        <p className="text-white/70 mt-5 max-w-lg">Paste your tour link. You'll see it in our skin with menus, info windows and the AI assistant switched on. The demo lasts 24 hours and nothing is saved.</p>
        <form onSubmit={go} className="mt-10 rounded-3xl border border-white/10 bg-white/[0.03] p-6" data-testid="g360-demo-form">
          <label className="text-sm text-white/70 flex items-center gap-2"><Link2 className="w-4 h-4 text-[#C9A227]" />Giraffe360 tour link</label>
          <div className="mt-3 flex flex-col sm:flex-row gap-3">
            <input required type="url" value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://tour.giraffe360.com/…" className="flex-1 h-12 rounded-full bg-white/5 border border-white/15 px-5 text-white placeholder:text-white/30" data-testid="g360-demo-url" />
            <button disabled={busy} className="h-12 px-7 rounded-full bg-[#C9A227] text-slate-950 font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-60" data-testid="g360-demo-go">{busy && <Loader2 className="w-4 h-4 animate-spin" />}Show my tour</button>
          </div>
          {err && <p className="text-sm text-rose-300 mt-3" data-testid="g360-demo-error">{err}</p>}
          <OwnerBadge base="/giraffe" />
        </form>
      </main>
    </div>
  );
}
